import React from 'react';

/**
 * Einheitliche Ladeanzeige für Schrittwechsel und asynchrone Datenabrufe.
 * Der Text bleibt für Screenreader verfügbar; die Kreisbewegung ist rein dekorativ.
 */
export default function Spinner({label, overlay = false}) {
  return (
    <div className={overlay ? 'pf-spinner-overlay' : 'pf-spinner-block'} role="status" aria-live="polite">
      <span className="pf-spinner" aria-hidden="true" />
      <span>{label}</span>
    </div>
  );
}
